import {
    CHANGE_TAB,
} from "./actionTypes";

export const changeTab = payload => ({
    type: CHANGE_TAB,
    payload: payload
});